import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type IsAllInfoUnavailableProps = {
  index: number
}

export const IsAllInfoUnavailable = ({ index }: IsAllInfoUnavailableProps) => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name={`subjectsInfo.${index as 0}.isAllInfoUnavailable`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          input={(props) => <CheckBox {...props} checkBoxLabel="if all critical* subject information is unavailable" />}
        />
      )}
    />
  )
}
